/*@ngInject*/
const UserActionUtil = function ($rootScope, $state, loadingBarHandler, modalUtil, userActionMediator, userLoginType,
                                 uiPerformanceLoggerConstant, coreConstant) {

    this.cancel = function (userId) {
        modalUtil.showConfirmationModal(
            /*submissionId*/null,
            /*quoteId*/null,
            /*notificationName*/null,
            'user.cancelModal',
            uiPerformanceLoggerConstant.DELETE_USER,
            /*hideLoadingBar*/false,
            function () {
                return userActionMediator.deleteUser(userId).then(function () {
                    $state.go('userList', {userType: $state.params.userType});
                });
            });
    };

    this.deactivateUser = function (userId) {
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_USER);
        modalUtil.showConfirmationModal(
            null,
            null,
            null,
            'user.deactivateModal',
            uiPerformanceLoggerConstant.DEACTIVATE_USER,
            /*hideLoadingBar*/false,
            function () {
                let promise = userActionMediator.deactivateUser(userId).then(onSuccess, onError);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });

        function onSuccess() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_USER, coreConstant.uiPeformanceLogger.SUCCESS);
            $rootScope.$broadcast(coreConstant.event.RELOAD_USER);
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_USER, coreConstant.uiPeformanceLogger.FAIL);
        }
    };

    this.activateUser = function (userId) {
        loadingBarHandler.showLoadingBar('user.activate.loadingBar');
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_USER);

        userActionMediator.activateUser(userId).then(onSuccess, onError);

        function onSuccess(user) {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_USER, coreConstant.uiPeformanceLogger.SUCCESS);

            loadingBarHandler.hideLoadingBar();
            $rootScope.$broadcast(coreConstant.event.RELOAD_USER);

            if (!user.sentPassword && user.loginType !== userLoginType.SINGLE_SIGN_ON) {
                modalUtil.showConfirmationModal(
                    /*submissionId*/null,
                    /*quoteId*/null,
                    /*notificationName*/null,
                    'user.activate.sendPasswordModal',
                    uiPerformanceLoggerConstant.RESET_PASSWORD,
                    /*hideLoadingBar*/false,
                    function () {
                        let promise = userActionMediator.resetPassword(userId);
                        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                        return promise;
                    });
            }
        }

        function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_USER, coreConstant.uiPeformanceLogger.FAIL);
        }
    };

    this.resetPassword = function (userId) {
        modalUtil.showConfirmationModal(
            /*submissionId*/null,
            /*quoteId*/null,
            /*notificationName*/null,
            'user.resetPasswordModal',
            uiPerformanceLoggerConstant.RESET_PASSWORD,
            /*hideLoadingBar*/false,
            function () {
                let promise = userActionMediator.resetPassword(userId);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
    };

    this.createPassword = function (userId) {
        modalUtil.showConfirmationModal(
            /*submissionId*/null,
            /*quoteId*/null,
            /*notificationName*/null,
            'user.createPasswordModal',
            uiPerformanceLoggerConstant.CREATE_PASSWORD,
            /*hideLoadingBar*/false,
            function () {
                let promise = userActionMediator.resetPassword(userId);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
    };

    this.unlockUser = function (userId) {
        modalUtil.showConfirmationModal(
            /*submissionId*/null,
            /*quoteId*/null,
            /*notificationName*/null,
            'user.unlockUserModal',
            uiPerformanceLoggerConstant.UNLOCK_USER,
            /*hideLoadingBar*/false,
            function () {
                let promise = userActionMediator.unlockUser(userId);
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            });
    };

    this.getFormSetId = function (userId) {
        return userActionMediator.getFormSetId(userId);
    };
};

angular.module('umCore')
    .service('userActionUtil', UserActionUtil);
